module.exports = __webpack_public_path__ + "assets/media/morning.d9b900ee.mp3";